import { Get } from "../utils/api";
import { Product } from "../../types/api/Product";
import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";

export default (organizationId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery<Product[]>(`products_${organizationId}`, async () => {
    return await Get<Product[]>(
      `/api/product/organization/${organizationId}`,
      await getAccessTokenSilently()
    );
  });
};
